/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Oktoberfest} from "../Oktoberfest";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class OktoberfestFreespinIdlePresentation implements FlowStatePresentation {

    constructor() {
    }

    public async start(flowStateController: FlowStateController) {
        if (Oktoberfest.model.isRestore) {
            if (Oktoberfest.model.parsedInitData.freespinTriggeredThisSpin) {
                await new Promise<void>(resolve => {
                    Oktoberfest.freespinIntro.show(resolve);
                });
            } else {
                Oktoberfest.freespinIntro.initialiseFreeSpin();
                SlotGame.keypadPlugin.setZeroBetSpinCounter(Oktoberfest.model.parsedInitData.freespinsLeft - 1);
            }
        } else {
            SlotGame.keypadPlugin.setZeroBetSpinCounter(Oktoberfest.model.parsedGameData.freespinsLeft - 1);
        }
        SlotGame.apiPlugin.betHandler.zeroBet();
        flowStateController.finish();
    }
}